// import React from "react";
// import {
//   Button,
//   FormFieldSet,
//   Modal,
//   useFormHandler,
// } from "../../../../../../components";

// const EnterPassword = ({ isOpen, onClose }) => {
//   const { formData, errors, handleChange, validateAllFields, setFormData } =
//     useFormHandler({
//       password: "",
//     });

//   console.log("form data is :", formData.password);
//   return (
//     <Modal isOpen={isOpen} onClose={onClose} title="ENTER PASSWORD">
//       <div>
//         <FormFieldSet
//           title="Logged in as: abhi@tektreeinc.com"
//           type={"text"}
//           placeholder="Please Enter Password"
//           value={formData.password}
//           onChange={(value) => handleChange("password", value)}
//           error={errors.password}
//         />
//         <div>
//           <div className="flex gap-3 justify-end my-8">
//             <Button title="Cancel" variant="outlined" onClick={onClose} />
//             <Button title="Save" />
//           </div>
//         </div>
//       </div>
//     </Modal>
//   );
// };

// export default EnterPassword;

import React from "react";
import {
  Button,
  FormFieldSet,
  Modal,
  showToast,
  useFormHandler,
} from "../../../../../../components";
import { filterEmptyValues } from "../../../../../../utils/filterEmptyValues";
import axiosRequest from "../../../../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../../../../redux/apiConfig";
import CryptoJS from "crypto-js";
import { v4 as uuidv4 } from "uuid";
const EnterPassword = ({ isOpen, onClose, onSuccess, loginUserData }) => {
  const { formData, errors, handleChange, validateAllFields } = useFormHandler({
    password: "",
  });
  const ENCRYPTION_KEY = import.meta.env.VITE_AES_KEY;
  // Handle saving the password
  const handleSave = async () => {
    // onSuccess();
    const isValid = validateAllFields();
    if (isValid) {
      console.log("password", formData.password);
      const encryptedPassword = CryptoJS.AES.encrypt(
        formData?.password,
        ENCRYPTION_KEY
      ).toString();

      const payload = {
        coll:"User",
        payload:{
        email: loginUserData?.email?.primary || "",
        password: encryptedPassword,
          }
      };
      const submissionData = filterEmptyValues(payload);
      try {
        const response = await axiosRequest({
          method: "POST",
          url: ENDPOINTS.AUTH.VERIFY_PASSWORD, // Endpoint for verifying password
          data: submissionData,
        });
        // Handle response
        console.log(response); // Process the response data as needed
        if (response.success) {
          showToast("success", "success", 2000);
          onSuccess();
        } else {
          const msg =
            response?.msg === "Too many requests!"
              ? "Too many requests! please 15 minutes after try again!"
              : "Password is wrong please enter again!";
          showToast(msg, "error", 2000);
        }
      } catch (error) {
        console.log("error", error);
        // showToast("Timesheet found", "success", 2000);
        // Handle error
        console.error("Error during API request:", error);
        // Optionally, display an error message or notification
      }
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="ENTER PASSWORD"
      showCloseButton={true}
      closeOnOutsideClick={true}
    >
      <div>
        <FormFieldSet
          title={`Logged in as: ${loginUserData?.email?.primary || ""}`}
          type="password"
          noGenerate
          placeholder="Please Enter Password"
          value={formData.password}
          onChange={(e) => {
            console.log("e", e);
            handleChange("password", e.target.value);
          }}
          error={errors.password}
        />
        <div className="flex gap-3 justify-end my-8">
          <Button title="Cancel" variant="outlined" onClick={onClose} />
          <Button title="OK" onClick={() => handleSave()} />
        </div>
      </div>
    </Modal>
  );
};

export default EnterPassword;
